import script from "./examIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./examIndex.vue?vue&type=script&setup=true&lang=js"

import "./examIndex.vue?vue&type=style&index=0&id=68b66ae0&scoped=true&lang=scss"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b66ae0"]])

export default __exports__